<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on" elevation="0" class="mr-1" :small="$vuetify.breakpoint.mdAndDown">
        Aprovar
      </v-btn>
    </template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Gestão de reservas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialog = false"> Fechar </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-title>
            Aprovações/Pendentes
            <v-spacer></v-spacer>
            <v-btn @click.stop="loadAgendamentos" :loading="computedIsLoading" color="primary" elevation="0" class="mx-1">
                <v-icon small class="mr-2">mdi-refresh</v-icon> Atualizar
              </v-btn>
            <v-text-field outlined dense v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
            
        </v-card-title>
        <!-- Headers da tabela -->
        <v-card-text>
            <v-data-table 
                :headers="headers" 
                :items="$store.adminAgendamentosStore.state.agendas" 
                :search="search"
                :sort-by="['status_agenda','id']"
                :sort-desc="[true,true]"
                elevation="1" 
                no-data-text="Nenhuma reserva encontrada"
                no-results-text="Nenhuma reserva encontrada"
                loading-text="Carregando..."
                >
                <template v-slot:top>
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-select v-model="filtroMes" dense outlined :items="computedMeses" 
                                :disabled="computedIsLoading" @change="onChangeMonth"
                                item-value="value" item-text="text" label="Selecione o Mês"></v-select>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.id="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.id }}</strong>
                </template>
                <template v-slot:item.solicitante="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.solicitante }}</strong>
                </template>
                <template v-slot:item.status_agenda="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.status_agenda }}</strong>
                </template>
                <template v-slot:item.name="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.name }}</strong>
                </template>
                <template v-slot:item.data="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.data }}</strong>
                </template>
                <template v-slot:item.hora="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.hora }}</strong>
                </template>
                <!--
                <template v-slot:item.finalidade="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.finalidade }}</strong>
                </template>
                -->
                <!-- EDITAVEL ALUNO -->        
                <template v-slot:item.alunos="{ item }">
                    <span v-if="item.status_agenda != 'NEGADO'">
                        <v-edit-dialog :return-value.sync="item.alunos"  save-text="Alterar" cancel-text="Cancelar"
                            large auto-focus
                            :class="getColor(item.status_agenda)"
                            @save='patch_agendamento({id : item.id, alunos: item.alunos || 0})' 
                            @cancel='()=>{}' @open='()=>{}' @close='()=>{}'
                            >
                            
                            <strong :class="getColor(item.status_agenda)" >{{ item.alunos }}</strong>
                            <v-icon small>mdi-pencil</v-icon>
                            
                            <template v-slot:input>
                                <div class="mt-4 text-h7">
                                    Atualizar Qtde Alunos
                                </div>  
                                <v-divider class="my-2"></v-divider>
                                <v-text-field type="number" outlined dense
                                    v-model="item.alunos" 
                                    label="editar"
                                    hide-details>
                                    
                                </v-text-field>
                            </template>
                        </v-edit-dialog>
                    </span>
                    <span v-else>
                        <strong :class="getColor(item.status_agenda)" >{{ item.alunos}}</strong>
                    </span>
                    
                </template>
                
                <!-- EDITAVEL CODTURMA -->
                <template v-slot:item.codturma="{ item }">
                    <span v-if="item.status_agenda != 'NEGADO'">
                        
                        <v-edit-dialog :return-value.sync="item.codturma"  save-text="Alterar" cancel-text="Cancelar"
                            large auto-focus
                            :class="getColor(item.status_agenda)"
                            @save='patch_agendamento({id : item.id, codturma: item.codturma })' 
                            @cancel='()=>{}' @open='()=>{}' @close='()=>{}'
                            >
                            
                            <strong :class="getColor(item.status_agenda)" >{{ item.codturma }}</strong>
                            <v-icon small>mdi-pencil</v-icon>
                            
                            <template v-slot:input>
                                <div class="mt-4 text-h7">
                                    Atualizar Turma
                                </div>
                                <v-divider class="my-2"></v-divider>
                                <v-text-field type="text" outlined dense
                                    v-model="item.codturma" 
                                    label="editar"
                                    hide-details>
                                    
                                </v-text-field>
                            </template>
                        </v-edit-dialog>
                    </span>
                    <span v-else>
                        <strong :class="getColor(item.status_agenda)" >{{ item.codturma}}</strong>
                    </span>
                </template>

                <template v-slot:item.get_sala.sala="{ item }">
                    <div style="inline-size: max-content;">
                        <v-tooltip right >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text v-bind="attrs" v-on="on" small>
                                    <v-icon>mdi-account</v-icon> 
                                </v-btn>
                            </template>
                            <div>
                                {{item.solicitante}}
                            </div>
                        </v-tooltip>
                        <strong :class="getColor(item.status_agenda)" >
                            {{ item.get_sala.sala}}
                        </strong>
                    </div>
                </template>

                <template v-slot:item.get_formatted_data="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.get_formatted_data }}</strong>
                </template>

                <template v-slot:item.horario="{ item }">
                    <div style="inline-size: max-content;">
                        <v-tooltip right >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text v-bind="attrs" v-on="on" small>
                                    <v-icon>mdi-timer</v-icon> 
                                </v-btn>
                            </template>
                            <div>
                                {{ item.start }} às {{item.end}}
                            </div>
                        </v-tooltip>
                        <strong :class="getColor(item.status_agenda)" >
                            {{ item.start }} às {{item.end}}
                            <!--{{item.horario}} -->
                        </strong>
                    </div>
                </template>
                <!--
                <template v-slot:item.get_finalidade.descricao="{ item }">
                    <strong :class="getColor(item.status_agenda)" >{{ item.get_finalidade.descricao}}</strong>
                </template>
                <template v-slot:item.protocolos="{ item }">
                    <Protocolos :reserva="item" v-if="item.file_protocolo_pratica || item.file_reagentes_equipamentos" />
                </template>
                -->

                <template v-slot:item.aprovar="{ item }">
                    <div v-if="computedIsLoading">
                        <v-btn icon loading color="grey"></v-btn>
                    </div>
                    <div v-else>
                        <span v-if="item.status_agenda == 'NEGADO'">
                            <span v-if="$vuetify.breakpoint.smAndDown">
                                {{ item.status_ressalva }}
                            </span>
                            <span v-else>
                                <v-tooltip left >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon color="error" v-bind="attrs" v-on="on" >
                                            <v-icon >mdi-information</v-icon> 
                                        </v-btn>
                                    </template>
                                    <div>
                                        {{ item.status_ressalva }}
                                    </div>
                                </v-tooltip>
                            </span>
                        </span>
                        <span v-else>
                            <!--
                            <Aprovacao :reserva="item" 
                                @aprovado="aprovar($event ? { id:item.id, status_agenda:'APROVADO'} : {id:item.id, status_agenda:'NEGADO'})"/>
                            -->
                            <Aprovacao :reserva="item" @aprovado="aprovar($event)"/>
                        </span>
                    </div>
                </template>
                    
            </v-data-table>
        </v-card-text>
    </v-card>
</v-dialog>
</template>

<script>
import Aprovacao from '@/components/Aprovacao.vue'
import FrontendConfigService from '@/services/configs/frontendConfigService'


  export default {
    name: 'MeusAgendamentos',
    components:{
        Aprovacao //, Protocolos
    },
    data () {
      return {
        filtroMes:'',
        required: [v => (v||'').length > 0 || 'Campo obrigatório'],
        search:'',
        dialog: false,
        headers: [
          { text: 'ID', align: 'center', sortable: true, value: 'id', },
          //{ text: 'Solicitante', align: 'start', sortable: true, value: 'solicitante', },
          { text: 'Laboratório', align: 'start', sortable: true, value: 'get_sala.sala', },
          { text: 'Data', value: 'get_formatted_data', sortable: true },
          { text: 'Horario', value: 'horario', sortable: true },
          //{ text: 'Finalidade', value: 'get_finalidade.descricao', sortable: true },
          { text: 'Qtde Alunos', value: 'alunos'},
          { text: 'Turma', value:'codturma', width:"120px"},
          { text: 'Status', value: 'status_agenda', sortable: true },
          //{ text: 'Protocolos', value: 'protocolos'},
          { text: 'Aprovação', value: 'aprovar', align: 'center'}
        ],
      }
    },
    methods: {
        onChangeMonth(mes){
            //console.log(value)
            this.filtroMes = mes
            this.loadAgendamentos()
        },
        aprovar(agenda){
            if(agenda){
                let reserva = { id:agenda.id, status_agenda: agenda.status_agenda, status_ressalva: agenda.status_ressalva}
                this.$store.adminAgendamentosStore.dispatch('aprovar_reserva',reserva)
            }
        },
        patch_agendamento(agenda){
            if(agenda){
                this.$store.adminAgendamentosStore.commit('setLoading', true) 
                const patch = this.$store.adminAgendamentosStore.dispatch('patch_agenda',agenda)
                patch.then( response => {
                    this.$store.adminAgendamentosStore.commit('setNotifications', [
                        {
                            'tag':'success', 
                            'message': `Agendamento ${response.data.solicitante} - ${response.data.get_formatted_data} das ${ response.data.start} às ${response.data.end} atualizado com sucesso!`
                        }
                    ])
                    //this.$store.adminAgendamentosStore.dispatch('get_agendas','')
                    this.loadAgendamentos()
                }).catch( error => { 
                    console.error(error.response);
                    this.$store.adminAgendamentosStore.dispatch('tryError', error)
                }).finally( () => { 
                    this.$store.adminAgendamentosStore.commit('setLoading', false) 
                })
            }
        },
        loadAgendamentos(){
            if (!this.filtroMes){
                this.filtroMes = new Date().getMonth()+1
            }

            this.$store.adminAgendamentosStore.dispatch('get_agendas',`?mes=${this.filtroMes}`)
            //this.$store.adminAgendamentosStore.dispatch('get_agendas','')
        },
        aprovacao(value){
            let status = value ? 'APROVADO':'NEGADO'
            return status
        },
        getColor (status) {
            let cor = ''
            switch(status){
            case 'PENDENTE': cor = 'warning--text'; break;
            case 'NEGADO': cor = 'error--text'; break;
            case 'APROVADO': cor = 'success--text'; break;
            default: cor = 'black--text';
            }
            return cor
        },
    },
    computed:{
        computedIsLoading(){
            return this.$store.adminAgendamentosStore.getters.getIsLoading
        },
        computedNotifications(){
            return this.$store.adminAgendamentosStore.getters.getNotifications
        },
        computedMeses(){
            return this.$store.globalStore.getters.getMonthsList
        }
    },
    mounted(){
        //this.loadAgendamentos()
    },
    watch:{
        computedNotifications:{
            handler(errors){
                for(let message of errors){
                    let options = FrontendConfigService.getOptionsToast()
                    this.$toast(message.message, {
                        type: message.tag,
                        ...options
                    })
                }
            }, deep:true
        }
    }
}
    
</script>

<style scoped>
.v-small-dialog__content .v-input:last-child{
    padding-bottom: 10px !important;
}
</style>